import React, { useState, useEffect } from 'react';
import Navbar from '../../dashboard/navbar';
import Sidebar from '../../dashboard/sidebar';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { Modal } from 'react-bootstrap'; // Importer la modal
import useAuth from '../../dashboard/useAuth';
import axios from 'axios';

const Modifier_groupe_processus = ({ titre }) => {
    useAuth();
    const location = useLocation();
    const user_id = localStorage.getItem('user_id');
    const { groupeProcessus_id } = location.state || {}; // On récupère l'ID du groupe depuis l'état de la location
    const navigate = useNavigate();

    // État pour stocker les données du groupe processus
    const [groupeProcessusData, setGroupeProcessusData] = useState({
        titre_fr: '',
        description_fr: '',
        ordre_fr: '',
        titre_en: '',
        description_en: '',
        ordre_en: '',
    });
    console.log(groupeProcessusData);

    const [originalGroupeProcessusData, setOriginalGroupeProcessusData] = useState({});
    const [showModal, setShowModal] = useState(false); // État pour contrôler la modal
    const [initialGroupeProcessusData, setInitialGroupeProcessusData] = useState(groupeProcessusData);

    // Utilisation de useEffect pour récupérer les données depuis l'API
    useEffect(() => {
        const fetchGroupeProcessusData = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_HOTE}/groupe-processus-info/${groupeProcessus_id}/`);
                if (response.ok) {
                    const data = await response.json();
                    // Directement accéder aux propriétés de data
                    setGroupeProcessusData({
                        titre_fr: data.titre_fr,
                        description_fr: data.description_fr,
                        ordre_fr: data.ordre_fr,
                        titre_en: data.titre_en, 
                        description_en: data.description_en,
                        ordre_en: data.ordre_en,
                    });
                    setOriginalGroupeProcessusData({
                        titre_fr: data.titre_fr,
                        description_fr: data.description_fr,
                        ordre_fr: data.ordre_fr,
                        titre_en: data.titre_en, 
                        description_en: data.description_en,
                        ordre_en: data.ordre_en,
                    });
                    setInitialGroupeProcessusData(data); // Ici, data est l'objet complet
                } else {
                    console.error('Erreur lors de la récupération des données du groupe processus');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            }
            
        };

        fetchGroupeProcessusData();
    }, [groupeProcessus_id]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        const dataToSend = {
            titre_fr: groupeProcessusData.titre_fr,
            description_fr: groupeProcessusData.description_fr,
            titre_en: groupeProcessusData.titre_en,
            description_en: groupeProcessusData.description_en,
            ordre_fr: groupeProcessusData.ordre_fr,
            ordre_en: groupeProcessusData.ordre_en,
        };

        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/modifier-groupe-processus/${groupeProcessus_id}/`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(dataToSend),
            });

            if (!response.ok) {
                const errorData = await response.json();
                console.error('Erreur:', errorData);
            } else {
                const data = await response.json();
                console.log('Succès:', data);
                navigate(`/Liste-groupe-processus?user_id=${user_id}`);
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    // Fonction pour ouvrir la modal
    const handleShowModal = (event) => {
        event.preventDefault();
        setShowModal(true);
    };

    // Fonction pour fermer la modal
    const handleCloseModal = () => {
        setShowModal(false);
    };

    // Fonction pour annuler et remettre à zéro les champs
    const handleConfirmCancel = () => {
        setGroupeProcessusData(originalGroupeProcessusData); // Réinitialiser les données originales
        setShowModal(false);
    };

    // Fonction pour réinitialiser les données
    const handleReset = () => {
        setGroupeProcessusData(initialGroupeProcessusData); // Réinitialiser aux valeurs initiales
        navigate(`/Liste-groupe-processus?user_id=${user_id}`);
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');
  
    const verifGroupe = async () => {
      const groupeStored = localStorage.getItem('groupe');
      const accesGroupeStored = localStorage.getItem('accesGroupe');
  
      if (groupeStored && accesGroupeStored) {
        setGroupeId(groupeStored);
        setAccesGroupe(JSON.parse(accesGroupeStored));
      } else {
        try {
          const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
          if (response.status === 200) {
            const data = response.data;
            setGroupeId(data.groupe);
  
            let cleanedAccessArray = [];
            if (Array.isArray(data.acces)) {
              cleanedAccessArray = data.acces.map((item) =>
                item.acces
                  ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                  : []
              ).flat();
  
              setAccesGroupe(cleanedAccessArray);
            }
  
            localStorage.setItem('groupe', data.groupe);
            localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
          }
        } catch (error) {
          // console.error('Erreur lors de la vérification du groupe', error);
        }
      }
    };
  
    useEffect(() => {
      if (user_id) {
        verifGroupe();
      }
    }, [user_id]);
  
    if (!accesGroupe.includes("QCM")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">

                    <div className="col-lg-12">
                            <h2 className="mb-1"><i className="fa fa-bookmark-o"></i> Modification du Groupe Processus {initialGroupeProcessusData.titre_fr}</h2>
                            <small>Admisnistration des Groupes processus qui correspondent aux cours ou chapitres</small>
                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={'/admin'}>Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={'/Liste-groupe-processus'}>Groupes Processus</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        Modification du Groupe Processus {initialGroupeProcessusData.titre_fr}
                                    </li>
                                </ol>
                            </small>
                        </div>

                        {/* <div className="col-lg-12">
                            <h2>Modification du Groupe Processus {initialGroupeProcessusData.titre_fr}</h2>
                            <ol className="breadcrumb custom-breadcrumb">
                                <li className="breadcrumb-item custom-breadcrumb-item">
                                    <Link to={`/dashboard`}>Dashboard</Link>
                                </li>
                                <li className="breadcrumb-item custom-breadcrumb-item">
                                    <Link to={`/admin`}>Administration</Link>
                                </li>
                                <li className="breadcrumb-item custom-breadcrumb-item">
                                    <Link to={`/Liste_groupe_processus`}>Groupe Processus</Link>
                                </li>
                                <li className="breadcrumb-item custom-breadcrumb-item">
                                    Modification du Groupe Processus {initialGroupeProcessusData.titre_fr}
                                </li>
                            </ol>
                        </div> */}
                    </div>

                    <div className="col-lg-8 mx-auto m-1 p-1">
                        <div className="ibox ">
                            <form className="m-t" role="form" onSubmit={handleSubmit}>
                                <div className="ibox-title">
                                    <h5>Groupe Processus</h5>
                                </div>
                                <div className="ibox-content">
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <div className="ibox ">
                                                <div className="ibox-title justify-content p-1">
                                                    <h4>Version Française</h4>
                                                </div>
                                                <div className="ibox-content">
                                                    <div className="form-group">
                                                        <label>Titre<span style={{ color: 'red' }}>*</span></label>
                                                        <input
                                                            type="text"
                                                            className="form-control mb-4"
                                                            required
                                                            name="titre_fr"
                                                            value={groupeProcessusData.titre_fr}
                                                            onChange={(e) => setGroupeProcessusData({ ...groupeProcessusData, titre_fr: e.target.value })}
                                                        />
                                                        <label>Description</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="description_fr"
                                                            value={groupeProcessusData.description_fr}
                                                            onChange={(e) => setGroupeProcessusData({ ...groupeProcessusData, description_fr: e.target.value })}
                                                        />
                                                        <label>Ordre</label>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="ordre_fr"
                                                            value={groupeProcessusData.ordre_fr}
                                                            onChange={(e) => setGroupeProcessusData({ ...groupeProcessusData, ordre_fr: e.target.value })}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="ibox ">
                                                <div className="ibox-title justify-content p-1">
                                                    <h4>Version Anglaise</h4>
                                                </div>
                                                <div className="ibox-content">
                                                    <div className="form-group">
                                                        <label>Title<span style={{ color: 'red' }}>*</span></label>
                                                        <input
                                                            type="text"
                                                            className="form-control mb-4"
                                                            required
                                                            name="titre_en"
                                                            value={groupeProcessusData.titre_en}
                                                            onChange={(e) => setGroupeProcessusData({ ...groupeProcessusData, titre_en: e.target.value })}
                                                        />
                                                        <label>Description</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="description_en"
                                                            value={groupeProcessusData.description_en}
                                                            onChange={(e) => setGroupeProcessusData({ ...groupeProcessusData, description_en: e.target.value })}
                                                        />
                                                        <label>Order</label>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="ordre_en"
                                                            value={groupeProcessusData.ordre_en}
                                                            onChange={(e) => setGroupeProcessusData({ ...groupeProcessusData, ordre_en: e.target.value })}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="ibox-footer d-flex justify-content-end">
                                    <Link to='/Liste-groupe-processus' className="btn btn-default mr-2">Annuler</Link>
                                    <button type="reset" className="btn btn-default mr-2" onClick={handleReset}>Effacer</button>
                                    <button type="submit" className="btn btn-success">Enregistrer</button>
                                </div>
                            </form>
                        </div>
                    </div>

                </div>
            </div>

            {/* Modal de confirmation */}
            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Êtes-vous sûr de vouloir annuler les modifications ?
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={handleCloseModal}>Non</button>
                    <button className="btn btn-success" onClick={handleConfirmCancel}>Oui</button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default Modifier_groupe_processus;
